import { Routes } from "@angular/router";
import { LoginComponent } from "./auth/login/login.component";
import { LogoutComponent } from "./auth/logout/logout.component";
import { authGuard } from "./guards/auth.guard";
import { editAccessGuard } from "./guards/edit-access.guard";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "logout", component: LogoutComponent },
  {
    path: "dashboard",
    loadComponent: async () =>
      (await import("./dashboard/dashboard.component")).DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: "configure",
    loadComponent: async () =>
      (await import("./configuration/configuration.component"))
        .ConfigurationComponent,
    canActivate: [authGuard, editAccessGuard],
  },
  {
    path: "configure/:id",
    loadComponent: async () =>
      (await import("./configuration/configuration.component"))
        .ConfigurationComponent,
    canActivate: [authGuard],
  },
  {
    path: "configure/:id/edit",
    loadComponent: async () =>
      (await import("./configuration/configuration.component"))
        .ConfigurationComponent,
    canActivate: [authGuard, editAccessGuard],
  },
  {
    path: "configurations/new",
    redirectTo: "configure",
    pathMatch: "full",
  },
  {
    path: "configurations/:id/edit",
    redirectTo: "configure/:id/edit",
    pathMatch: "full",
  },
  { path: "", pathMatch: "full", redirectTo: "dashboard" },
  { path: "**", redirectTo: "dashboard" },
];
